export const environment = {
    production: false,
    //apiURL: "http://52.169.222.136:8070/", //NOTE: this is sample api. please replace it with your api url.
    apiURL: "https://bsl-dev-apim.azure-api.net/adminapi/", //NOTE: this is sample api. please replace it with your api url.
    appLogoPath: "assets/images/softweb-logo.svg"
};